import axios, { AxiosError } from 'axios';

import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '@/lib/queryKeys';
import { userData } from '@/types/types';
import { API_URL } from '@/lib/apiUrl';

export const useUserData = (options = {}) => {
  // Create an Axios instance with minimal configuration
  const axiosInstance = axios.create({
    baseURL: API_URL,
    withCredentials: true,
  });

  return useQuery({
    queryKey: queryKeys.userData.current.queryKey,
    queryFn: async () => {
      const response = await axiosInstance.get<userData>('/api/v1/user');
      return response.data;
    },
    retry: (failureCount, error) => {
      // Don't retry on 401 (unauthorized) or 403 (forbidden) errors
      // as these indicate authentication issues, not temporary failures
      if (
        error instanceof AxiosError &&
        (error.response?.status === 401 || error.response?.status === 403)
      ) {
        return false;
      }
      // Retry up to 3 times for other errors
      return failureCount < 3;
    },
    ...options,
  });
};
